// 初期表示
export const PAGE_INIT = "corp/loan/PAGE_INIT";
// 表示条件の更新
export const CONDITIONS_UPDATE = "corp/loan/CONDITIONS_UPDATE";
// データ初期化
export const DATA_RESET = "corp/loan/DATA_RESET";
